import {
  put, takeLatest, all, takeEvery,
} from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import ZohoIntegrationActions, { zohoIntegrationActionTypes } from '../../actions/integrations/zohoIntegrationActions';
import ZohoIntegrationServices from '../../services/integrations/zohoIntegrationServices';

/**
 * @param action
 */
function* _getZohoConnections(action) {
  try {
    const {
      orgId, callback,
    } = action;
    yield put(ZohoIntegrationActions.getZohoConnectionsLoading(true));
    const linkedZohoAccounts = yield ZohoIntegrationServices.getZohoConnections(orgId);
    yield put(ZohoIntegrationActions.getZohoConnectionsSuccess(linkedZohoAccounts?.result));
    if (linkedZohoAccounts.success) {
      if (callback) {
        callback(linkedZohoAccounts.result);
      }
    }
    yield put(ZohoIntegrationActions.getZohoConnectionsLoading(false));
  } catch (error) {
    yield put(ZohoIntegrationActions.getZohoConnectionsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(zohoIntegrationActionTypes.GET_ZOHO_CONNECTIONS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getZohoConnections() {
  yield takeLatest(zohoIntegrationActionTypes.GET_ZOHO_CONNECTIONS.REQUEST, _getZohoConnections);
}

/**
 * @param action
 */
function* _updateZohoConnection(action) {
  try {
    const { payload, callback } = action;
    yield put(ZohoIntegrationActions.updateZohoConnectionLoading(true));
    const updateConnection = yield ZohoIntegrationServices.updateZohoConnection(payload);
    if (updateConnection.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Zoho Connection Updated.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: updateConnection.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ZohoIntegrationActions.updateZohoConnectionLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ZohoIntegrationActions.updateZohoConnectionLoading(false));
    yield put(TrackerActions.trackAction(zohoIntegrationActionTypes.UPDATE_ZOHO_CONNECTION.ERROR, error));
  }
}
/**
 *
 */
function* updateZohoConnection() {
  yield takeLatest(zohoIntegrationActionTypes.UPDATE_ZOHO_CONNECTION.REQUEST, _updateZohoConnection);
}

/**
 * @param action
 */
function* _connectToZoho(action) {
  try {
    const { orgId, callback } = action;
    yield put(ZohoIntegrationActions.connectToZohoLoading(true));
    const connectToZohoData = yield ZohoIntegrationServices.connectToZoho(orgId);
    yield put(ZohoIntegrationActions.connectToZohoSuccess(connectToZohoData));

    if (connectToZohoData.result && connectToZohoData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Connected to Zoho Books Successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(ZohoIntegrationActions.connectToZohoLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: connectToZohoData.message,
        duration: 4,
        placement: 'top',
      });
    }
  } catch (error) {
    yield put(ZohoIntegrationActions.connectToZohoLoading(false));
    yield put(TrackerActions.trackAction(zohoIntegrationActionTypes.CONNECT_TO_ZOHO.ERROR, error));
  }
}
/**
 *
 */
function* connectToZoho() {
  yield takeEvery(zohoIntegrationActionTypes.CONNECT_TO_ZOHO.REQUEST, _connectToZoho);
}

/**
 * @param action
 */
function* _connectTenantToLocation(action) {
  try {
    const { payload, callback } = action;
    yield put(ZohoIntegrationActions.connectTenantToLocationLoading(true));
    const connectToZohoData = yield ZohoIntegrationServices.connectTenantToLocation(payload);
    if (connectToZohoData.success) {
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: connectToZohoData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ZohoIntegrationActions.connectTenantToLocationLoading(false));
  } catch (error) {
    yield put(ZohoIntegrationActions.connectTenantToLocationLoading(false));
    yield put(TrackerActions.trackAction(zohoIntegrationActionTypes.CONNECT_TENANT_TO_LOCATION.ERROR, error));
  }
}
/**
 *
 */
function* connectTenantToLocation() {
  yield takeLatest(zohoIntegrationActionTypes.CONNECT_TENANT_TO_LOCATION.REQUEST, _connectTenantToLocation);
}

/**
 * @param action
 */
function* _syncProduct(action) {
  try {
    const { payload, callback } = action;
    yield put(ZohoIntegrationActions.syncProductLoading(true));
    const syncVendorData = yield ZohoIntegrationServices.syncProduct(payload);
    if (syncVendorData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Product synced successfully with Zoho Books.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncVendorData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ZohoIntegrationActions.syncProductLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ZohoIntegrationActions.syncProductLoading(false));
    yield put(TrackerActions.trackAction(zohoIntegrationActionTypes.SYNC_ZOHO_PRODUCT.ERROR, error));
  }
}
/**
 *
 */
function* syncProduct() {
  yield takeLatest(zohoIntegrationActionTypes.SYNC_ZOHO_PRODUCT.REQUEST, _syncProduct);
}

/**
 * @param action
 */
function* _syncVendor(action) {
  try {
    const { payload, callback } = action;
    yield put(ZohoIntegrationActions.syncVendorLoading(true));
    const syncVendorData = yield ZohoIntegrationServices.syncVendor(payload);
    if (syncVendorData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Vendor synced successfully with Zoho Books.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncVendorData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ZohoIntegrationActions.syncVendorLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ZohoIntegrationActions.syncVendorLoading(false));
    yield put(TrackerActions.trackAction(zohoIntegrationActionTypes.SYNC_ZOHO_VENDOR.ERROR, error));
  }
}
/**
 *
 */
function* syncVendor() {
  yield takeLatest(zohoIntegrationActionTypes.SYNC_ZOHO_VENDOR.REQUEST, _syncVendor);
}

/**
 * @param action
 */
function* _syncGRN(action) {
  try {
    const { payload, callback } = action;
    yield put(ZohoIntegrationActions.syncGRNLoading(true));
    const syncGRNData = yield ZohoIntegrationServices.syncGRN(payload);
    if (syncGRNData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'GRN synced successfully with Zoho Books.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncGRNData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ZohoIntegrationActions.syncGRNLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ZohoIntegrationActions.syncGRNLoading(false));
    yield put(TrackerActions.trackAction(zohoIntegrationActionTypes.SYNC_ZOHO_GRN.ERROR, error));
  }
}

/**
 *
 */
function* syncGRN() {
  yield takeLatest(zohoIntegrationActionTypes.SYNC_ZOHO_GRN.REQUEST, _syncGRN);
}
/**
 * @param action
 */
function* _syncPO(action) {
  try {
    const { payload, callback } = action;
    yield put(ZohoIntegrationActions.syncPOLoading(true));
    const syncPOData = yield ZohoIntegrationServices.syncPO(payload);
    if (syncPOData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Purchase Order synced successfully with Zoho Books.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncPOData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ZohoIntegrationActions.syncPOLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ZohoIntegrationActions.syncPOLoading(false));
    yield put(TrackerActions.trackAction(zohoIntegrationActionTypes.SYNC_ZOHO_PO.ERROR, error));
  }
}
/**
 *
 */
function* syncPO() {
  yield takeLatest(zohoIntegrationActionTypes.SYNC_ZOHO_PO.REQUEST, _syncPO);
}

/**
 * @param action
 */
function* _syncDN(action) {
  try {
    const { payload, callback } = action;
    yield put(ZohoIntegrationActions.syncDNLoading(true));
    const syncDNData = yield ZohoIntegrationServices.syncDN(payload);
    if (syncDNData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Debit Note synced successfully with Zoho Books.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncDNData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ZohoIntegrationActions.syncDNLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ZohoIntegrationActions.syncDNLoading(false));
    yield put(TrackerActions.trackAction(zohoIntegrationActionTypes.SYNC_ZOHO_DN.ERROR, error));
  }
}

/**
 *
 */
function* syncDN() {
  yield takeLatest(zohoIntegrationActionTypes.SYNC_ZOHO_DN.REQUEST, _syncDN);
}

/**
 * @param action
 */
function* _syncCN(action) {
  try {
    const { payload, callback } = action;
    yield put(ZohoIntegrationActions.syncCNLoading(true));
    const syncCNData = yield ZohoIntegrationServices.syncCN(payload);
    if (syncCNData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Credit Note synced successfully with Zoho Books.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncCNData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ZohoIntegrationActions.syncCNLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ZohoIntegrationActions.syncCNLoading(false));
    yield put(TrackerActions.trackAction(zohoIntegrationActionTypes.SYNC_ZOHO_CN.ERROR, error));
  }
}
/**
 *
 */
function* syncCN() {
  yield takeLatest(zohoIntegrationActionTypes.SYNC_ZOHO_CN.REQUEST, _syncCN);
}

/**
 * @param action
 */
function* _syncInvoice(action) {
  try {
    const { payload, callback } = action;
    yield put(ZohoIntegrationActions.syncInvoiceLoading(true));
    const syncInvoiceData = yield ZohoIntegrationServices.syncInvoice(payload);
    if (syncInvoiceData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Invoice synced successfully with Zoho Books.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncInvoiceData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ZohoIntegrationActions.syncInvoiceLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ZohoIntegrationActions.syncInvoiceLoading(false));
    yield put(TrackerActions.trackAction(zohoIntegrationActionTypes.SYNC_ZOHO_INVOICE.ERROR, error));
  }
}
/**
 *
 */
function* syncInvoice() {
  yield takeLatest(zohoIntegrationActionTypes.SYNC_ZOHO_INVOICE.REQUEST, _syncInvoice);
}

/**
 * @param action
 */
function* _pullProducts(action) {
  try {
    const { payload, callback } = action;
    // yield put(ZohoIntegrationActions.pullProductsLoading(true));
    if (callback) {
      callback();
    }
    // notification.open({
    //   type: 'success',
    //   message: 'Please wait while we pulling products, vendors and customers data from Zoho Books. This might take upto 30 minutes to complete.',
    //   duration: 6,
    //   placement: 'top',
    // });
    const pullProductsData = yield ZohoIntegrationServices.pullProducts(payload);
    if (pullProductsData.success) {
      notification.open({
        type: 'success',
        message: 'We have successfully synced your products data from Zoho Books to Procuzy.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: pullProductsData.message,
        duration: 4,
        placement: 'top',
      });
    }
    // yield put(ZohoIntegrationActions.pullProductsLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ZohoIntegrationActions.pullProductsLoading(false));
    yield put(TrackerActions.trackAction(zohoIntegrationActionTypes.PULL_ZOHO_PRODUCTS.ERROR, error));
  }
}
/**
 *
 */
function* pullProducts() {
  yield takeLatest(zohoIntegrationActionTypes.PULL_ZOHO_PRODUCTS.REQUEST, _pullProducts);
}

/**
 * @param action
 */
function* _pullVendors(action) {
  try {
    const { payload, callback } = action;
    // yield put(ZohoIntegrationActions.pullVendorsLoading(true));
    if (callback) {
      callback();
    }
    const pullVendorsData = yield ZohoIntegrationServices.pullVendors(payload);
    if (pullVendorsData.success) {
      notification.open({
        type: 'success',
        message: 'We have successfully synced your vendors data from Zoho Books to Procuzy.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: pullVendorsData.message,
        duration: 4,
        placement: 'top',
      });
    }
    // yield put(ZohoIntegrationActions.pullVendorsLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ZohoIntegrationActions.pullVendorsLoading(false));
    yield put(TrackerActions.trackAction(zohoIntegrationActionTypes.PULL_ZOHO_VENDORS.ERROR, error));
  }
}
/**
 *
 */
function* pullVendors() {
  yield takeLatest(zohoIntegrationActionTypes.PULL_ZOHO_VENDORS.REQUEST, _pullVendors);
}

/**
 * @param action
 */
function* _pullCustomers(action) {
  try {
    const { payload, callback } = action;
    yield put(ZohoIntegrationActions.pullCustomersLoading(true));
    const pullCustomersData = yield ZohoIntegrationServices.pullCustomers(payload);
    if (pullCustomersData.success) {
      notification.open({
        type: 'success',
        message: 'We have successfully synced your customers data from Zoho Books to Procuzy.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: pullCustomersData.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (callback) {
      callback();
    }
    yield put(ZohoIntegrationActions.pullCustomersLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ZohoIntegrationActions.pullCustomersLoading(false));
    yield put(TrackerActions.trackAction(zohoIntegrationActionTypes.PULL_ZOHO_CUSTOMERS.ERROR, error));
  }
}
/**
 *
 */
function* pullCustomers() {
  yield takeLatest(zohoIntegrationActionTypes.PULL_ZOHO_CUSTOMERS.REQUEST, _pullCustomers);
}

/**
 * @param action
 */
function* _deleteZohoConnection(action) {
  try {
    const { payload, callback } = action;
    yield put(ZohoIntegrationActions.deleteZohoConnectionLoading(true));
    const deleteZohoConnectionResponse = yield ZohoIntegrationServices.deleteZohoConnection(payload);
    if (deleteZohoConnectionResponse.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Zoho connection deleted successfully.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: deleteZohoConnectionResponse.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ZohoIntegrationActions.deleteZohoConnectionLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message || 'An error occurred while deleting the Zoho connection.',
      duration: 4,
      placement: 'top',
    });
    yield put(ZohoIntegrationActions.deleteZohoConnectionLoading(false));
    yield put(TrackerActions.trackAction(zohoIntegrationActionTypes.DELETE_ZOHO_CONNECTION.ERROR, error));
  }
}

/**
 *
 */
function* deleteZohoConnection() {
  yield takeLatest(zohoIntegrationActionTypes.DELETE_ZOHO_CONNECTION.REQUEST, _deleteZohoConnection);
}

function* _syncDocument(action) {
  try {
    const { payload, callback } = action;
    yield put(ZohoIntegrationActions.zohoAutomaticDocumentSyncLoading(true));
    const syncDocumentData = yield ZohoIntegrationServices.syncZohoDocument(payload);
    if (syncDocumentData.success) {
      if (callback) {
        callback();
      }
      notification.open({
        type: 'success',
        message: 'Document synced successfully with Zoho Books.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: syncDocumentData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ZohoIntegrationActions.zohoAutomaticDocumentSyncLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ZohoIntegrationActions.zohoAutomaticDocumentSyncLoading(false));
    yield put(TrackerActions.trackAction(zohoIntegrationActionTypes.SYNC_DOCUMENT.ERROR, error));
  }
}

function* syncDocument() {
  yield takeLatest(zohoIntegrationActionTypes.SYNC_DOCUMENT.REQUEST, _syncDocument);
}

export default function* zohoIntegrationSaga() {
  yield all([
    getZohoConnections(),
    updateZohoConnection(),
    connectToZoho(),
    connectTenantToLocation(),
    syncProduct(),
    syncVendor(),
    syncGRN(),
    syncPO(),
    syncDN(),
    syncCN(),
    syncInvoice(),
    pullProducts(),
    pullVendors(),
    pullCustomers(),
    deleteZohoConnection(),
    syncDocument(),
  ]);
}
